export enum E_ShareType {
    TECH_MIND = 'TECH_MIND',
    PROJECT = 'WORK_PROJECT',
    TRIZ_MIND = 'TRIZ_MIND',
    RD_TECH_MIND = 'RD_TECH_MIND',
    RD_TECH_MIND_AGENT = 'RD_TECH_MIND_AGENT',
    TRIZ_PRO = 'TRIZ_PRO',
    TRIZ_SKILL = 'RD_TRIZ_MIND_AGENT',
    DEEPCOST = 'RD_DEEP_COST'
}

export enum ShareRole {
    OWNER = 'OWNER',
    COLLABORATOR = 'COLLABORATOR'
}

export interface ShareAuthRequiredData {
    id: string;
    type: E_ShareType;
    triggerButtonSource?: string;
}
